import { useEffect, useState } from 'react';

export const useHasMount: () => boolean = () => {
	const [hasMounted, setHasMounted] = useState(false);
	useEffect(() => {
		setHasMounted(true);
	}, []);

	return hasMounted;
};
